import type { EndpointsRegistry, FetchClient } from '~/api/types'
import { GatewayEndpoints } from '~/api/endpoints/gateway-endpoints'
import type { SuccessNoContent } from '~/types/common'
import type { UserActivityMessage } from '~/types/user-activity'

export interface UserActivityResponse {
  session_id?: string
}

export interface BeaconService {
  send: (payload: BeaconPayload) => Promise<SuccessNoContent[]>
  sendUserActivity: (message: UserActivityMessage) => Promise<UserActivityResponse>
}

export const registerEndpoints = (client: FetchClient, registry: EndpointsRegistry): BeaconService => {
  return {
    send: async (payload: BeaconPayload): Promise<SuccessNoContent[]> => {
      const { url, method, headers, body } = registry.createRequest(GatewayEndpoints.BEACON_POST, {}, { ...payload })
      return await client(url, { method, headers, body })
    },
    sendUserActivity: async (message: UserActivityMessage): Promise<UserActivityResponse> => {
      const { url, method, headers, body } = registry.createRequest(
        GatewayEndpoints.USER_ACTIVITY_POST,
        {},
        { ...message }
      )
      return await client(url, { method, headers, body })
    }
  }
}
